// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2gQVg","title":"Info_title__3OJSf","selects":"Info_selects__3AuIO","requiredAsterisk":"Info_requiredAsterisk__8r0D8"};